import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Tue Aug 15 2018
 * @author SKu
 * @author BPo
 */
import * as React from 'react';
import VSelect from 'react-virtualized-select';
import { Creatable } from 'react-select';
import { Utils } from '@logio/common-be-fe';
import Icon, { IconColor, IconType } from '../../media/Icon';
import StyledLabel from '../../typography/Label';
import SelectStyled from './styled/SelectStyled';
import SelectWrapper from './styled/SelectWrapper';
import withValidation from '../../inputs/withValidation';
import { showIf } from '../../../shared/rendering/showIf';
import Tooltip from '../../info/Tooltip';
import { TooltipType } from '../../info/Tooltip/TooltipType';
/**
 * [See DOCS for react-virtualized-select](https://github.com/bvaughn/react-virtualized-select)
 */

var Select =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Select, _React$PureComponent);

  function Select() {
    var _this;

    _classCallCheck(this, Select);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).apply(this, arguments));

    _this.onChange = function (option) {
      if (!Utils.isArray(option)) {
        _this.props.onChange(option ? option.value : '');
      } else {
        var values = option.map(function (_ref) {
          var value = _ref.value;
          return value;
        });

        _this.props.onChange(values);
      }
    };

    return _this;
  }
  /**
   * Try to find label by the given value
   * @param value Option value
   */


  _createClass(Select, [{
    key: "getLabel",
    value: function getLabel(value) {
      if (Utils.isArray(this.props.options)) {
        var option = this.props.options.find(function (optionItem) {
          return optionItem.value === value;
        });

        if (option) {
          return option.label;
        }
      }

      return '';
    }
    /**
     * Checks if the placeholder value is array. If so, this method joins values with comma.
     */

  }, {
    key: "getPlaceholder",
    value: function getPlaceholder() {
      var _this2 = this;

      if (Utils.isArray(this.props.placeholder)) {
        var labels = this.props.placeholder.map(function (value) {
          return _this2.getLabel(value);
        });
        return labels.join(', ');
      } else if (Utils.isString(this.props.placeholder)) {
        return this.props.placeholder;
      }

      return '';
    } // private sortOptions(options: FormElOption[]): FormElOption[] {
    //   const sortFunc = (a: FormElOption, b: FormElOption): number => {
    //     if (Utils.isString(a.label) && Utils.isString(b.label)) {
    //       const labelA = a.label.toUpperCase();
    //       const labelB = b.label.toUpperCase();
    //       return (labelA !== labelB ? (labelA < labelB ? -1 : 1) : 0);
    //     }
    //     return 0;
    //   };
    //
    //   return !Utils.isValueMissing(options) ? options.sort(sortFunc) : [];
    // }
    //
    // private setEmptyOption(options: FormElOption[]): FormElOption[] {
    //   if (!this.props.multi) {
    //     options.unshift({ label: '', value: undefined })
    //   }
    //   return options;
    // }
    //
    // get getOptions(): SelectOptions {
    //   let options: FormElOption[] = this.props.options || [];
    //   // TODO: disabled for performance reasons
    //   // options = this.sortOptions(options);
    //   if (options.length && options[0].label !== '') {
    //     // options = this.setEmptyOption(options);
    //   }
    //
    //   return {
    //     options,
    //     filterOptions: createFilterOptions({options}),
    //     optionsRenderer: this.props.optionsRenderer,
    //   }
    // }

  }, {
    key: "renderLabel",
    value: function renderLabel() {
      if (this.props.labelTooltipText) {
        return React.createElement(StyledLabel, null, this.props.label, ' ', React.createElement(Tooltip, {
          tooltipType: TooltipType.Unstyled,
          overlay: this.props.labelTooltipText
        }, React.createElement("div", null, React.createElement(Icon, {
          iconType: IconType.info,
          iconColor: IconColor.Text,
          iconHeight: 14
        }))));
      }

      return React.createElement(StyledLabel, null, this.props.label);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(React.Fragment, null, this.props.label && this.renderLabel(), React.createElement(SelectWrapper, {
        tiny: this.props.tiny,
        withIconIn: this.props.withIconIn,
        className: "input-wrapper"
      }, React.createElement(SelectStyled, {
        tiny: this.props.tiny,
        multi: this.props.multi
      }, React.createElement(VSelect, Object.assign({}, this.props, {
        placeholder: this.getPlaceholder(),
        onChange: this.onChange,
        classNamePrefix: "react-select",
        autosize: false,
        matchProp: "label",
        selectComponent: this.props.creatable ? Creatable : undefined
      })), showIf(this.props.selectIconType, React.createElement("div", {
        className: "input-icon"
      }, React.createElement(Icon, {
        iconType: this.props.selectIconType,
        iconHeight: 20,
        iconColor: IconColor.Text
      }))))));
    }
  }]);

  return Select;
}(React.PureComponent);

export default Select; // Export input with validation wrapper.

export var SelectValidated = withValidation(Select);